<mat-slide-toggle [checked]="status" [(ngModel)]="status" class="position-relative end-0 top-0"
    (change)="toggleStatusDependency($event)" [matTooltip]="status ? 'Disable Status' :'Enable Status'"
    matTooltipPosition="right"></mat-slide-toggle>
